var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 235") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-options",
    transform: "translate(-445.000000, -715.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-235",
    transform: "translate(445.000000, 715.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2566136,12.4674545 C14.1488864,12.6222273 13.9368409,12.6590455 13.7820682,12.552 L10.4609318,10.227 L5.90297727,10.227 L2.58184091,12.552 C2.42775,12.6604091 2.21570455,12.6229091 2.10729545,12.4674545 C1.99888636,12.3133636 2.03638636,12.1013182 2.19115909,11.9935909 L5.60025,9.60722727 C5.65752273,9.567 5.72570455,9.54518182 5.79525,9.54518182 L10.5679773,9.54518182 C10.6382045,9.54518182 10.7063864,9.567 10.7636591,9.60722727 C10.7636591,9.60722727 14.17275,11.9929091 14.17275,11.9935909 C14.3275227,12.1013182 14.3650227,12.3133636 14.2566136,12.4674545 L14.2566136,12.4674545 Z M12.1266136,9.14359091 C11.9711591,9.25131818 11.7584318,9.21313636 11.6513864,9.05836364 C11.5443409,8.90290909 11.5832045,8.69086364 11.7372955,8.58381818 L15.9475227,5.66836364 L8.37661364,0.402 C8.25934091,0.320863636 8.10456818,0.320863636 7.98729545,0.402 L0.416386364,5.66836364 L4.62661364,8.58381818 C4.78070455,8.69086364 4.81956818,8.90290909 4.71184091,9.05836364 C4.60479545,9.21313636 4.39275,9.25131818 4.23729545,9.14359091 L-0.000204545455,6.21040909 L-0.000204545455,13.6360909 C-0.000204545455,14.3874545 0.612068182,14.9997273 1.36343182,14.9997273 L14.9997955,14.9997273 C15.7518409,14.9997273 16.3634318,14.3874545 16.3634318,13.6360909 L16.3634318,6.21040909 L12.1266136,9.14359091 Z",
    id: "Fill-3080"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email_icon.33f8ccde6c6d04ba196ba35300dd72f7.svg";